"use client";
import styled from "@emotion/styled";
import { AxisAndBackground } from "@/types/cssTypes";
import {
  NEUTRO_BLANK_COLOR,
  NEUTRO_PARAGRAPHS_COLOR,
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  PRIMARY_BUTTON_COLOR_DISSABLED,
} from "@/utils/constants";

export const CustomInput = styled.input<AxisAndBackground>`
  width: ${({ width }) => width};
  min-width: 200px;
  border: 1px solid ${({ color }) => color ?? PRIMARY_BUTTON_COLOR_DISSABLED};
  border-radius: 16px;
  font-style: normal;
  font-weight: 300;
  color: ${NEUTRO_TITLES_COLOR};
  height: 48px;
  padding: 12px 14px 14px 12px;
  background: ${NEUTRO_BLANK_COLOR};
  font-size: 14px;
  letter-spacing: 0.3px;
  margin-top: ${({ marginY }) => marginY};

  &::placeholder {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    color: ${NEUTRO_PARAGRAPHS_COLOR};
    letter-spacing: 0.3px;
  }

  &:focus {
    outline: none !important;
    border: 1px solid ${PRIMARY_BUTTON_COLOR} !important;
  }

  &:hover {
    &::placeholder {
      color: ${NEUTRO_TITLES_COLOR};
    }
    border: 1px solid ${PRIMARY_BUTTON_COLOR};
  }
  &:disabled {
    background: ${PRIMARY_BUTTON_COLOR_DISSABLED};
    border: 1px solid ${PRIMARY_BUTTON_COLOR_DISSABLED};
  }
`;

export const CustomSelect = styled.select<AxisAndBackground>`
  width: ${({ width }) => width};
  min-width: 200px;
  border: 1px solid ${({ color }) => color ?? PRIMARY_BUTTON_COLOR_DISSABLED};
  border-radius: 16px;
  font-style: normal;
  font-weight: 300;
  color: ${NEUTRO_TITLES_COLOR};
  height: 48px;
  padding: 12px 14px 14px 12px;
  background: ${NEUTRO_BLANK_COLOR};
  font-size: 14px;
  letter-spacing: 0.3px;
  margin-top: ${({ marginY }) => marginY};
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background-image: url("https://www.svgrepo.com/show/80156/down-arrow.svg");
  background-repeat: no-repeat;
  background-size: 10px 10px;
  background-position: calc(100% - 20px);

  &::placeholder {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    color: ${NEUTRO_PARAGRAPHS_COLOR};
    letter-spacing: 0.3px;
  }

  &:focus {
    outline: none !important;
    border: 1px solid ${PRIMARY_BUTTON_COLOR} !important;
  }

  &:hover {
    &::placeholder {
      color: ${NEUTRO_TITLES_COLOR};
    }
    border: 1px solid ${PRIMARY_BUTTON_COLOR};
  }
  &:disabled {
    background: ${PRIMARY_BUTTON_COLOR_DISSABLED};
    border: 1px solid ${PRIMARY_BUTTON_COLOR_DISSABLED};
  }
`;

export const InputWithNoBorder = styled.input<AxisAndBackground>`
  width: ${({ width }) => width};
  min-width: 180px;
  border: none;
  font-style: normal;
  font-weight: 300;
  color: ${NEUTRO_TITLES_COLOR};
  height: 35px;
  margin-top: 4px;
  border-radius: 16px;
  padding: 0px 12px 0px 12px;
  background: ${NEUTRO_BLANK_COLOR};
  font-size: 14px;
  letter-spacing: 0.3px;

  &::placeholder {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    color: ${NEUTRO_PARAGRAPHS_COLOR};
    letter-spacing: 0.3px;
  }

  &:focus-visible {
    border: none;
    outline: none;
  }

  &:hover {
    &::placeholder {
      color: ${NEUTRO_TITLES_COLOR};
    }
  }
`;

export const TextAreaWithFixedHeight = styled.textarea<AxisAndBackground>`
  width: ${({ width }) => width};
  min-width: 180px;
  border: 1px solid ${PRIMARY_BUTTON_COLOR_DISSABLED};
  font-style: normal;
  font-weight: 300;
  font-family: Roobert, sans-serif;
  color: ${NEUTRO_TITLES_COLOR};
  height: ${({ height }) => height};
  border-radius: 12px;
  padding: 12px 14px 14px 12px;
  background: ${NEUTRO_BLANK_COLOR};
  font-size: 14px;
  letter-spacing: 0.3px;
  margin-top: ${({ marginY }) => marginY};
  resize: none;

  &::placeholder {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    font-family: Roobert, sans-serif;
    color: ${NEUTRO_PARAGRAPHS_COLOR};
    letter-spacing: 0.3px;
  }

  &:focus {
    outline: none !important;
    border: 1px solid ${PRIMARY_BUTTON_COLOR} !important;
  }

  &:hover {
    &::placeholder {
      color: ${NEUTRO_TITLES_COLOR};
    }
    border: 1px solid ${PRIMARY_BUTTON_COLOR};
  }
`;
